import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { forwardRef, memo, } from 'react';
import { ReactPortal } from '../ReactPortal';
const defaultProps = {
    open: false,
    zIndex: 999999,
};
const Popover = forwardRef(({ children, open = defaultProps.open, zIndex = defaultProps.zIndex, }, ref) => (_jsx(ReactPortal, { children: _jsx("div", Object.assign({ css: css `
        display: ${open ? 'block' : 'none'};
        z-index: ${zIndex};
      `, ref: ref }, { children: children })) })));
Popover.displayName = 'Popover';
const MemoizedPopover = memo(Popover);
export { MemoizedPopover as Popover };
// MC-1068 Temporary hack for Storybook.
export default Popover;
